var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-login-bg"},[_c('div',{staticClass:"wx-login"},[_c('img',{staticClass:"login-close",attrs:{"src":_vm.close_img},on:{"click":_vm.wxloginHide}}),_c('div',{attrs:{"id":"login_container"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }